<template>

</template>

<script>
    export default {
        name: "error-403"
    }
</script>

<style scoped>

</style>
